import { useTranslation } from 'react-i18next'

import { formatMoneyShort } from '@percent/utility'
import { useMoneyFormat } from '@percent/workplace-giving/common/hooks'
import { useTotalDonatedCard } from './useTotalDonatedCard'
import { DashboardMetricCard } from '@percent/workplace-giving/common/components/DashboardMetricCard/DashboardMetricCard'
import { AppRoute } from '@percent/workplace-giving/routing/AppRoute.enum'

export function TotalDonatedCard(): JSX.Element {
  const {
    t,
    i18n: { language }
  } = useTranslation()
  const { isLoading, totalDonated, partnerName, titleTooltipKey } = useTotalDonatedCard()
  const { moneyFormat } = useMoneyFormat()

  return (
    <DashboardMetricCard
      title={t('workplace_giving.totalDonated.title')}
      titleTooltip={
        titleTooltipKey
          ? t(`workplace_giving.totalDonated.titleTooltip.${titleTooltipKey}`, {
              partnerName,
              interpolation: { escapeValue: false }
            })
          : undefined
      }
      value={moneyFormat(totalDonated)}
      compactValue={formatMoneyShort(totalDonated, { locale: language, roundingMode: 'floor' })}
      isLoading={isLoading}
      icon="donate-outline"
      description={t('workplace_giving.common.thisFiscalYear')}
      testId="total-donated-card"
      href={AppRoute.DONATE}
    />
  )
}
